import initTooltips from '../includes/tooltips.js';
import SavedFilters from '../includes/filters.js';
import * as userSettings from '../includes/user-settings.js';
import stockList, { loadResults } from './stock-list.js';

let section;
let form;
let currentGroup;
let currentGroups;

const importWatchlist = {
	duplicateRow: function (obj,newVal){

		let outterRow = obj.parent().parent()
		let generated = outterRow.clone().insertAfter(outterRow)

		generated.children(".import-watchlist-btn:first").on('click',function(event){
			$(this).parent().remove()
		});
		generated.children(".import-watchlist-btn:first").removeClass("not-removable");

		console.log(generated.find(".import-watchlist-input").html())

		let generatedInput = generated.find(".import-watchlist-input")

		generatedInput.val(newVal.toUpperCase())
		generatedInput.on('paste',importWatchlist.pasteEvent)

		return generatedInput
	},
	pasteEvent: function (event){
		var paste = (event.originalEvent.clipboardData || window.clipboardData).getData('text');

		let candidates = paste.split(/[ ,;\n]+/)

		candidates = candidates.filter(v=>v!="")


		let inputs = [$(this)]
		inputs[0].val(candidates[0])
		for (let i=1; i<candidates.length; i++){

			inputs[i]=importWatchlist.duplicateRow($(this),candidates[i])

		}
		inputs[inputs.length-1].focus()

		return false;
	},
	submitSymbol: function(symbol){
		return new Promise ((resolve)=>{
			ajax('watchlistAdd', { group_id: currentGroup.id, symbol }, resolve, resolve, true);
		})
	},
	resetList: function(){
		$(".watchlist-import-list .row").not(':first').remove()
		$(".import-watchlist-input").val("")

		$(".import-watchlist-input").removeClass("border-red")
		$(".import-watchlist-input").removeClass("border-green")
	},
	init: function(){

		console.log("INIT WATCHLIST IMPORT")

		$('#import-watchlists-modal').on('paste', 'input[type=text]', importWatchlist.pasteEvent);

		$('#import-watchlists-modal').on('keydown', 'input[type=text]', function(ev) {


			if (['Enter',",",";"," "].indexOf(ev.key)>=0) {
				//ev.stopPropagation();

				let newObj = importWatchlist.duplicateRow($(this),"")

				newObj.focus()
				// Avoid form submit
				return false;
			}
		});
		$('.import-watchlist-btn').on('click',function(event){
			$(this).parent().remove()
		});

		$(".import-watchlist-reset").on('click',importWatchlist.resetList);

		$(".import-watchlist-form").on("submit",async(e)=>{
			e.preventDefault()

			$(".import-watchlist-submit").attr("disabled","disabled");
			$(".import-watchlist-submit").html($(".import-watchlist-submit").data("loading-text"))

			let inputs = $(".import-watchlist-input")
			inputs.attr("disabled","disabled")

			let symbols = inputs.map(function(){return this.value})

			console.log("SYMBOLS",symbols)

			let group_id = $(".section-watchlist").find('.watchlist-results').data("group")

			console.log("GROUP",group_id);

			let promises = []

			for (let i=0; i< symbols.length; i++){
				promises[i]=importWatchlist.submitSymbol(symbols[i])

			}
			let results = await Promise.all(promises)
			console.log("PROMISES RESULTS",results);

			let errors = [] , success = 0
			for (let i=0; i<results.length; i++){
				if (results[i].success){
					success++
					inputs[i].classList.add("border-green")
				}else{
					errors.push(symbols[i])
					inputs[i].classList.add("border-red")
				}
			}

			inputs.removeAttr("disabled");
			$(".import-watchlist-submit").html($(".import-watchlist-submit").data("loaded-text"))
			$(".import-watchlist-submit").removeAttr("disabled");
			reloadWatchlist()

			alert(`${success} symbols imported succesfully.
			${(errors.length>0?`There was an error importing: ${errors.reduce((p,c,i)=>p+","+c)}`:'')}
			`)
			if (errors.length==0){
				importWatchlist.resetList()
				$('#import-watchlists-modal').modal('hide')
			}

		})
	},
}

function reloadWatchlist(preventReload) {
	loadResults();
};

function setWatchlistGroup(group_id) {
	const group = currentGroups.find(group => +group.id === +group_id);

	form.set('watchlist_group_id', group.id);
	currentGroup = group;
	userSettings.set('last_watchlist', group.id);

	document.getElementById('watchlist-title').textContent = currentGroup.title;
}

function swapStock(group_id, old_symbol, new_symbol){
	ajax('watchlistSwap', { group_id: group_id, old_symbol: old_symbol, new_symbol: new_symbol }, () => {
		reloadWatchlist();
	});
};

function reloadGroups(groups){
	let content = "", addtoContent="";

	for (let i=0;i<groups.length;i++){

		//Reload watchlist modal
		content+=`<a href="#" class="list-group-item" data-group="`+groups[i].id+`">`;
		if (!groups[i].default_group){
			content +=`<button type="button" class="btn btn-link pull-right watchlist-group-remove" data-group="`+groups[i].id+`">
						<i class="fa-regular fa-xmark"></i>
					</button>`
		}

		content+=groups[i].title+`</a>`;

		//Reload add to watchlist universal modal
		addtoContent += `
			<div class="list-group-item">
				<label for="add-to-watchlist-`+groups[i].id+`" >
					`+groups[i].title+`
					<input type="radio" class="pull-right"	name="group_id" id="add-to-watchlist-`+groups[i].id+`" value="`+groups[i].id+`" >
				</label>
			</div>
		`;

	}
	$('#saved-watchlists-load-modal .list-group').html(content);
	$("#add-to-watchlists-modal .list-group").html(addtoContent);
	sortGroups($('#saved-watchlists-load-modal'));

	currentGroups = groups;
};

function toggleRecommendations() {
	console.log("toggle recommendations")

	const value = !!+section.find('input[name="recommendations"]').val();

	$("#watchlist-btn-recommendations").toggleClass('active', !value);
	section.find('input[name="recommendations"]').val(value ? 0 : 1);

	reloadWatchlist();
}

function symbolFormCallback(stock) {
	addSymbol(stock.symbol);
}

//sort
function toggleSort(modal) {
	let sort = ['default', 'desc' ].includes(modal.data('sort')) ? 'asc' : 'desc';
	modal.data('sort', sort);

	//update sort icons
	if ( modal.data('sort') == 'asc' ){
		modal.find('.sort-icon-default').hide();
		modal.find('.sort-icon-desc').hide();
		modal.find('.sort-icon-asc').show();
	} else {
		modal.find('.sort-icon-default').hide();
		modal.find('.sort-icon-desc').show();
		modal.find('.sort-icon-asc').hide();
	}
}

function sortGroups(modal) {
	if ( modal.data('sort') == 'default' ) return;//nothing to do

	let sort = modal.data('sort');
	let groups = modal.find('.list-group a');
	let sorted = groups.toArray().sort(function(a,b){
		let ret = $(a).text().trim().toLowerCase() < $(b).text().trim().toLowerCase() ? -1 : 1;
		return sort=='asc' ? ret : ret*-1;
	});
	modal.find('.list-group').html(sorted);
}

async function addSymbol(symbol) {
	await importWatchlist.submitSymbol(symbol);

	reloadWatchlist();
}

async function watchlist(r, sectionDiv, originalData, callbacks) {
	section = sectionDiv;

	const page = await stockList(r, sectionDiv, { symbolFormCallback });

	form = page.formObj;
	currentGroups = r.groups;

	setWatchlistGroup(r.current_group_id);

	sectionDiv
		.on('click', '.watchlist-remove', function(e) {
			e.preventDefault();

			const symbol = $(this).data("symbol");

			if (!confirm('Are you sure you wish to remove ' + symbol + ' from your watchlist?')) {
				return;
			}

			ajax('watchlistRemove', { symbol: symbol, group_id: currentGroup.id }, function(res) {
				console.log("reload by watchlistRemove");
				reloadWatchlist();
			});
		})
		.on('click', '.watchlist-signal-alert-btn', function(e) {
			e.preventDefault();

			const symbol = $(this).data("symbol");
			const signal = +$(this).data('signal');

			$(this).toggleClass("active", signal === 0);
			$(this).data("signal", 1 - signal);

			if (!confirm('Are you sure you wish to ' + (signal === 1 ? 'remove' : 'activate') + ' ' + symbol + ' signal alert?')) {
				return;
			}

			ajax('watchlistStockSignalTrigger', { symbol: symbol, group_id: currentGroup.id, signal_alert: 1 - signal }, function(res) {
				console.log("Signal status set");
			});
		})
		.on('click', '.watchlist-symbol-swap', function(e) {
			e.preventDefault();

			const new_symbol = $(this).data('alternative');
			const old_symbol = $(this).data('symbol');

			if (!confirm(`Are you sure you wish to swap ${old_symbol} with ${new_symbol} in your watchlist?`)) {
				return;
			}

			swapStock(currentGroup.id, old_symbol, new_symbol);
		})

	$('#printWatchlist').on('click', function(e) {
		e.preventDefault();

		window.print();

		return false;
	});

	$('#saved-watchlists-btn').prop('disabled', false);

	//select group trigger
	$('#saved-watchlists-load-modal').on('click', '.list-group-item', function(e) {
		e.preventDefault();
		console.log("Watchlist selected: "+$(this).data("title")+" "+$(this).data("group"));

		const group_id = $(this).data("group");
		setWatchlistGroup(group_id);

		$('#saved-watchlists-load-modal').modal('hide');
	});

	//remove group trigger
	$('#saved-watchlists-load-modal').on('click', '.watchlist-group-remove', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		//console.log("Watchlist removed:"+$(this).data("group"))

		const group_id = $(this).data("group");

		if (!confirm('Are you sure you wish to delete this watchlist?')) {
			return;
		}

		$(this).parent().hide();

		ajax('watchlistGroupRemove', { group_id }, function(res) {
			reloadGroups(res.groups);

			if (+group_id === +currentGroup.id) {
				const defaultGroup = currentGroups.find(group => +group.default_group === 1);

				setWatchlistGroup(defaultGroup.id);
			}
		});
	});

	//save group trigger
	$('#saved-watchlists-save-modal')
		.off('submit')
		.on({
			submit: function(e) {
				e.preventDefault();
				var that = $(this),
					data = that.find('form').serializeJSON();
				console.log("automagically catch form submit");

				that.find(':submit').button('loading');

				let symbols = $(".watchlist-results tbody tr").toArray().map(e=>e.dataset.symbol);
				data.symbols=[]//symbols;

				ajax('watchlistGroupAdd', data, function(res) {
					reloadGroups(res.groups);
					console.log("reload by watchlist group add trigger")
					setWatchlistGroup(res.group_id);
					that.modal('hide');
					that.find(':submit').button('reset');
				},function(e){
					that.find(':submit').button('reset');
				});
			},
			'hidden.bs.modal': function() {
				$(this).find('form')[0].reset();
			}
		});

	//sort group trigger
	$('#saved-watchlists-load-modal').on('click', '.sort-icon', function(e) {
		e.preventDefault();

		let modal = $(this).closest('#saved-watchlists-load-modal');
		toggleSort(modal);
		sortGroups(modal);
	});

	$('#edit-watchlists-modal')
		.off('submit')
		.on({
			submit: function(e) {
				e.preventDefault();
				var that = $(this),
					data = that.find('form').serializeJSON();

				data.group_id = currentGroup.id;
				console.log("automagically catch form submit");
				console.log(data)
				that.find(':submit').button('loading');

				ajax('watchlistGroupEdit', data, function(res) {
					reloadGroups(res.groups);
					console.log("reload by watchlist group add trigger")
					reloadWatchlist();
					that.modal('hide');
					that.find(':submit').button('reset');
					setWatchlistGroup(currentGroup.id);
				},function(e){
					that.find(':submit').button('reset');
				});
			},
			'hidden.bs.modal': function() {
				$(this).find('form')[0].reset();
			},
			'show.bs.modal': function() {
				console.log('edit modal opened', currentGroup);
				this.querySelector('[name="title"]').value = currentGroup.title;
				if ( this.querySelector('[name="newsletter_frequency"]') ) {
					this.querySelector(`[name="newsletter_frequency"][value="${currentGroup.newsletter_frequency}"]`).checked = true;
				}
			},
		});

	//save date alert trigger
	$('#watchlists-trigger-modal').on({
		submit: function(e) {
			e.preventDefault();
			var that = $(this),
				data = that.find('form').serializeJSON();

			data.group_id = currentGroup.id;
			console.log("automagically catch form submit");
			console.log(data);

			that.find(':submit').prop('disabled', true).text('Saving...');
			that.find('.btn-danger').prop('disabled', true);


			let symbols = $(".watchlist-results tbody tr").toArray().map(e=>e.dataset.symbol);
			data.symbols=symbols;
			console.log(data)
			ajax('watchlistGroupTrigger', data, function(res) {

				console.log(res);
				if (res.success){
					console.log("Current value:"+that.find('input[name=trigger]').val());
					that.find('input[name=trigger]').val(res.trigger_alert);
				}

				that.data('opener').data("trigger-date",data.trigger);
				that.data('opener').data("trigger-notes",data.notes);
				// that.data('opener').parent().attr("title","Remind me on "+data.trigger);
				that.data('opener').addClass("active");

				that.modal('hide');
				that.find(':submit').prop('disabled', false).text('Save');
				that.find('.btn-danger').prop('disabled', false);
			},function(e){
				that.find(':submit').prop('disabled', false).text('Save');
				that.find('.btn-danger').prop('disabled', false);
			});

		},
		'show.bs.modal': function(event){
			let button = $(event.relatedTarget) // Button that triggered the modal
			let trigger_date = button.data('trigger-date')
			let trigger_notes = button.data('trigger-notes')

			let symbol = button.data('symbol')
			let modal = $(this)
			console.log(trigger_date);

			if (trigger_date != ""){
				$('#watchlists-trigger-modal .btn-danger').show();
			}else{
				$('#watchlists-trigger-modal .btn-danger').hide();
			}

			modal.data('opener', button);
			modal.find('.modal-body input[name=trigger]').val(trigger_date)
			modal.find('.modal-body input[name=symbol]').val(symbol)
			modal.find('.modal-body textarea[name=notes]').val(trigger_notes)
		}
	});

	$('#watchlists-trigger-modal .btn-danger').on('click',function(e){
		let that = $('#watchlists-trigger-modal');

		let data = that.find('form').serializeJSON();
		data.group_id = currentGroup.id;

		that.find('.btn-danger').prop('disabled', true).text('Removing...');
		that.find(':submit').prop('disabled', true);

		console.log(data)
		ajax('watchlistStockTriggerRemove', data, function(res) {

			console.log(res);
			if (res.success){
				that.find('input[name=trigger]').val("");
			}

			that.data('opener').data("trigger-date","");
			// that.data('opener').parent().attr("title","Set stock date trigger alert");
			that.data('opener').removeClass("active");

			that.modal('hide');
			that.find('.btn-danger').prop('disabled', false).text('Remove');
			that.find(':submit').prop('disabled', false);

		},function(e){
			that.find(':submit').prop('disabled', false).text('Save');
			that.find('.btn-danger').prop('disabled', false).text('Remove');
		});

	});

	$("#watchlist-btn-recommendations").on('click', toggleRecommendations);

	importWatchlist.init();
};

export default watchlist;
export { reloadWatchlist };
